
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const denari: Operator = {
	id: 'denari',
	name: 'Denari',
	role: 'Defender',
	org: 'NIGHTHAVEN',
	squad: 'NIGHTHAVEN',
	ratings: {
		health: 1,
		speed: 3,
		difficulty: 3
	},
	meta: {
		gender: 'm',
		country: 'ch',
		season: 'Y10S3',
		height: 190,
		weight: 73,
		price: {
			renown: 25000,
			r6credits: 600
		}
	},
	bio: {
		real_name: 'Leon Winzenried',
		birthplace: 'Lugano, Switzerland'
	},
	svg: {
		contents: '<path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M325.721 44.556 194.358 72.992l-18.715-10.805-41.461 22.738-61.172 16.391v89.775l13.242-7.646v25.9l-27.385 15.811v29.229l49.951-28.545 26.23 15.91-110.326 65.535 253.697-57.619.277-89.936-15.756 9.096v-31.158l27.957-16.141V95.31l-27.254 15.734L237.1 95.72l88.619-51.164Zm-150.078 34.15v41.965l36.344-20.982v41.965l36.342-20.982v83.932l-36.342-20.982v41.965l-36.344-20.982v41.965l-36.344-20.982-36.342-20.982 36.342-20.982-36.342-20.984 36.342-20.982-36.342-20.982 36.342-20.982 36.344-20.982Zm-36.344 20.982v41.965l36.344-20.982zm36.344 20.983v41.965l36.344-20.982zm36.344 20.982v41.967l36.342-20.984-36.342-20.982Zm0 41.967-36.344-20.984v41.967l36.344-20.982Zm-36.344 20.982-36.344-20.982v41.965l36.344-20.982Zm-36.344-20.982 36.344-20.984-36.344-20.982z" style="fill:#c82127"></path><path d="M175.643 204.602v41.965l36.344-20.982-36.344-20.982Zm36.344-20.982v41.965l36.344-20.982-36.344-20.982Zm-36.344-20.983v41.965l36.344-20.982-36.344-20.982Zm36.343-20.983v41.965l36.344-20.982-36.344-20.982Z"></path><path d="M139.3 99.689v41.965l36.344-20.982L139.3 99.69Z" style="fill:#fff"></path><path d="M175.643 120.671v41.965l36.344-20.982-36.344-20.982Zm0-41.965v41.965l36.344-20.982-36.344-20.982Z" style="fill:#fff"></path><path d="M211.986 99.688v41.965l36.344-20.982-36.344-20.982Z" style="fill:#fff"></path>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-denari'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
